import { render, staticRenderFns } from "./StudentHomeRich.vue?vue&type=template&id=3f8a0c30&scoped=true&"
import script from "./StudentHomeRich.vue?vue&type=script&lang=js&"
export * from "./StudentHomeRich.vue?vue&type=script&lang=js&"
import style0 from "./StudentHomeRich.vue?vue&type=style&index=0&id=3f8a0c30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8a0c30",
  null
  
)

export default component.exports